import React, { useEffect, useState } from "react"
import { useStore } from "../../stores/RootStoreContext"
import { ModalPopUp } from "../common/element/ModalPopUp"
import { Header } from "../common/header/Header"
import { IMG } from "../common/CONST"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { MenuManager } from "./MenuManager"
import { IModalMessage } from "../../types/error/IModalMessage"
import { IUpdateProfileDto } from "../../types/user/IUpdateProfileDto"
import { ManagerQuickActions } from "./ManagerQuickActions"
import { Brockman } from "../admin/Brockman"

export const ManagerDashboard = () => {
  const { userStore } = useStore()
  const [profile, setProfile] = useState<IUpdateProfileDto>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  useEffect(() => {
    TrinityAPI.getProfile(response => {
      if (response.status === 200) {
        setProfile(response.data)
      } else {
        setModalMessage({
          title: "Ошибка!",
          text: "Ошибка получения профиля: " + response.data.message
        })
      }
    })
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuManager active={"dashboard"} />
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Главная</h1>
          <div className="profile-block">
            <img src={IMG.main_logo} alt="" className="avatar-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{profile?.name}</h4>
              <p className="main-header-item-text">{userStore.getUser.username}</p>
            </div>
          </div>

          <ManagerQuickActions />
          <Brockman isManager />
        </div>
      </main>
    </>
  )
}
